import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { post, put, destroy as handleDelete } from '../modules/daily_product'
import { copy } from '../modules/pricelist'

import moment from 'helpers/moment'

import component from 'components/DailyProducts/Edit'

const mapActionCreators = {
  post,
  put,
  onSubmit: put,
  handleDelete, // NOTE: this cannot be named destroy as reduxForm uses that..
  copy
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(mapActionCreators, dispatch),
  dispatch
})

const mapStateToProps = (state, ownProps) => {
  let obj = {
    daily_product: state.daily_product,
    pricelist: state.pricelist,
    products: state.products,
    options: state.options,
    uoms: state.uoms,
    isLoggedIn: state.auth && state.auth.isLoggedIn,
    isAdmin: state.auth && state.auth.isAdmin
  }

  obj.date = moment(state.daily_product.date).format('YYYY-MM-DD')
  obj.daily_product.date = obj.date

  obj.initialValues = Object.assign({}, { prices: [] }, obj.daily_product)
  obj.initialValues.prices = obj.initialValues.prices.filter(o => o && o.price)
  obj.initialValues.prices.push({ price: undefined, uom_id: undefined, option_id: undefined })

  return obj
}

const form = reduxForm({
  form: 'edit-daily_product',
  fields: [
    'id', 'date', 'product_id', 'scientific_name', 'details', 'enabled',
    'tasting_notes', 'sourcing_location', 'sourcing_method', 'fishing_vessel',
    'prices[].price', 'prices[].uom_id', 'prices[].option_id'
  ],
  touchOnChange: true,
  validate (state) {
    var errors = {}
    if (!state.date) errors.date = 'Please enter a date.'
    if (!state.product_id) errors.product_id = 'Please select a product.'

    return errors
  }
})(component)

export default connect(mapStateToProps, mapDispatchToProps)(form)



// WEBPACK FOOTER //
// ./src/routes/DailyProducts/containers/EditDailyProductContainer.js